import { render, staticRenderFns } from "./PopupCheckout.vue?vue&type=template&id=48b7546b"
import script from "./PopupCheckout.vue?vue&type=script&lang=ts"
export * from "./PopupCheckout.vue?vue&type=script&lang=ts"
import style0 from "./PopupCheckout.vue?vue&type=style&index=0&id=48b7546b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports